// tslint:disable file-name-casing
import 'custom-event-polyfill';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxQueryProvider } from 'redux-query-react';
import configureStore from './helpers/reduxStore';
import LocaleRouter from './routers/LocaleRouter';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from './common/styles/theme/default';

const msalInstance = new PublicClientApplication(msalConfig);
const rootEl = document.getElementById('root');
export const store = configureStore();

if (document.documentElement) {
  document.documentElement.classList.remove('is-loading');
}

const root = createRoot(rootEl!);
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <ReduxQueryProvider queriesSelector={(state) => state.queries}>
        <ThemeProvider theme={defaultTheme}>
          <BrowserRouter>
            <LocaleRouter />
          </BrowserRouter>
        </ThemeProvider>
      </ReduxQueryProvider>
    </Provider>
  </MsalProvider>
);
